import productReducer from './product.slice'

export default productReducer
